import React from 'react';
import PropTypes from 'prop-types';
import Keywords from '../common/components/keywords';
import useGetKeywordsFromStockCodes from '../../../services/keywords/from-stock-codes-service';

export default function TopKeywords({ stockCode }) {
  const [{ data }, executeQuery] = useGetKeywordsFromStockCodes([stockCode.slug], 5);

  React.useEffect(() => {
    executeQuery();
  }, [executeQuery]);

  const props = { data, relation: 'related to', query: stockCode.companyName };
  return <Keywords {...props} />;
}

TopKeywords.propTypes = {
  stockCode: PropTypes.shape({
    stockExchange: PropTypes.string.isRequired,
    code: PropTypes.string.isRequired,
    companyName: PropTypes.string.isRequired,
    slug: PropTypes.string.isRequired,
  }).isRequired,
};
